import React from "react";
import {inject, observer} from "mobx-react";
import Logo from '../../assets/img/ak-mob3.svg';
import Indicazioni from '../../assets/img/sa/indicazioni.png'
import PhotoSelfie from '../../assets/img/sa/selfie_album_top.png';
import PhotoSelfieLogo from '../../assets/img/sa/PHOTOSELFIE.png';
import {toJS} from "mobx";
import Select from "material-ui/Select/Select";
import MenuItem from "material-ui/Menu/MenuItem";
import ImageUpload from "../../components/CustomUpload/ImageUpload";
import Snackbar from '../../components/Snackbar/Snackbar';
import AddPhoto from "@material-ui/icons/AddAPhoto";

import terms_conditions_privacy_policy_IT from '../../assets/pdfs/terms_conditions_privacy_policy_IT.pdf';
import terms_conditions_privacy_policy_EN from '../../assets/pdfs/terms_conditions_privacy_policy_EN.pdf';
import terms_conditions_privacy_policy_DE from '../../assets/pdfs/terms_conditions_privacy_policy_DE.pdf';
import terms_conditions_privacy_policy_ES from '../../assets/pdfs/terms_conditions_privacy_policy_ES.pdf';
import terms_conditions_privacy_policy_FR from '../../assets/pdfs/terms_conditions_privacy_policy_FR.pdf';

import {
    landing_page_max_photo_size,
    landing_page_min_photo_size,
    PHOTOSELFIE_BASE_URL,
    // PRIVACY_URL
} from "../../utils/constants";

import '../../assets/css/utenti.css';
import '../../assets/css/configuration.css';
import GridContainer from "../../components/Grid/GridContainer";
import ItemGrid from "../../components/Grid/ItemGrid";
import {Card} from "material-ui";

@inject('store')
@observer
class UploadPhotoRefactored extends React.Component {
    constructor(props) {
        super(props);
        this.store = this.props.store.appState;
        this.state = {
            utentname: '',
            utentlastname: '',
            email: '',
            confirmed_email: '',
            language: 'it',
            team: '',
            category: '',
            namelastname: '',
            categoryReferent: false,
            termini_condizioni: false,
            termini_condizioni_mail: false,
            errors: {},
            formIsValid: false,
            projectType: '',
            projectData: [],
            simpleProject: false,
            url_ok: false,
            showUploadError: false,
            tc: false,
            setTC: false,
            landing_page_enabled: true,
            showReferentCheckbox: true,
            athleteData: {
                name: '',
                lastname: '',
                team: null,
                category: null,
                photo: null,
                is_referent: false,
                referent_mail: '',
                projectID: null,
                photoID: null,
                name_lastname: null,
                teamID: null,
                categoryID: null
            },
            selectedCategory: null,
            selectedTeam: null,
            selectedAthlete: null,
            uploaded: false,
            team_passed_from_url: '',
            url_with_team: true,
        };

    }

    componentWillMount() {
        const self = this;
        let urlPath = self.props.history.location.pathname;

        if (urlPath.length < 1) {
            self.setState({url_ok: false});
            return;
        } else {
            if (urlPath.length < 0 || urlPath === '/upload-photo' || urlPath === '/upload-photo/') {
                self.setState({url_ok: false});
                return;
            } else {
                let fullUrl = PHOTOSELFIE_BASE_URL + urlPath;
                

                if (fullUrl.endsWith("/")){
                    fullUrl = fullUrl.substring(0, fullUrl.length - 1);
                    // console.log("NEW_URL", fullUrl)
                }

                const number = (fullUrl.match(/\//g) || []).length;

                // console.log((fullUrl.match(/\//g) || []).length);
                let finalUrl = fullUrl;
                let team_from_url = '';

                if(number === 5){
                    // 1- GET TEAM NAME FROM URL
                    team_from_url = fullUrl.substring(fullUrl.lastIndexOf('/') + 1);
                    // console.log("TEAM_FROM_URL", team_from_url);

                    const url_without_team = fullUrl.substring(0, fullUrl.lastIndexOf('/'));
                    // console.log("URL_WITHOUT_TEAM", url_without_team);
                    finalUrl = url_without_team;

                    self.setState({team_passed_from_url: team_from_url});
                }


                // console.log("FINAL URL", finalUrl);
                self.store.get_landing_page_data_by_url(finalUrl, function (res) {
                    // console.log("LANDING PAGE DATA: ", res);

                    if(team_from_url.length > 0) {
                        const projectData = res;
                        // let uniqueCategories = [...new Map(projectData.map(item => [item['CategoryName'], Object.assign({id: item.CategoryID,name: item.CategoryName})])).values()];
                        let uniqueTeams = [...new Map(projectData.map(item => [item['TeamName'], Object.assign({id: item.TeamID, name: item.TeamName})])).values()];
                        // console.log("UNIQUE TEAMS: ", uniqueTeams);
                        let teamFound = false;

                        res.forEach((athlete) => {
                            const team = athlete.TeamName.replace(/\s/g, "_").toLowerCase();
                            if (team === team_from_url) {
                                uniqueTeams.forEach((team) => {
                                    const teamName = team.name.replace(/\s/g, "_").toLowerCase();
                                    if (teamName === team_from_url) {
                                        self.setState({selectedTeam: team});
                                        teamFound = true;
                                    }
                                });
                            }
                        });

                        if(self.state.selectedTeam !== null){
                            self.selectTeamFromUrl(self.state.selectedTeam);
                        }

                        if (!teamFound) {
                            // console.log("TEAM FROM URL NOT FOUND!");
                            self.setState({url_with_team: false});
                        }
                    }


                    if (res) {
                        self.store.handle_app_lang(res[0].Language);
                        if (res[0].send_excel_to_ref === 0) {
                            self.setState({
                                showReferentCheckbox: false
                            });
                        }
                        self.setState({
                            language: res[0].Language,
                            projectType: res[0].ProjectType,
                            projectID: res[0].ProjectID,
                            projectData: res,
                            url_ok: true
                        });
                        if (res[0].landing_page_enabled === 0) {
                            self.setState({
                                landing_page_enabled: false
                            })
                        }
                    }
                });
            }
        }
    }

    componentDidMount() {
        document.body.style.background = '#235F84';
    }

    selectTeam = (event) => {
        const val = event.target.value;
        // console.log('Select Team', val);
        this.setState((prevState) => ({
            ...prevState,
            selectedTeam: val,
            selectedCategory: null,
            selectedAthlete: null,
            athleteData: {
                ...prevState.athleteData,
                team: val.name,
                teamID: val.id,
                name: '',
                lastname: '',
                category: null,
                categoryID: null
            },
            errors: {
                ...prevState.errors,
                team: ''
            }
        }))
    };

    selectCategory = (event) => {
        const val = event.target.value;
        this.setState((prevState) => ({
            ...prevState,
            selectedCategory: event.target.value,
            athleteData: {
                ...prevState.athleteData,
                category: val.name,
                categoryID: val.id,
                name: '',
                lastname: '',
                name_lastname: null,
                photoID: null
            },
            errors: {...this.state.errors, category: ''},
            selectedAthlete: null
        }))
    };

    selectTeamFromUrl = (team) => {
        // console.log('SELECTED TEAM', team);
        this.setState((prevState) => ({
            ...prevState,
            selectedTeam: team,
            selectedCategory: null,
            selectedAthlete: null,
            athleteData: {
                ...prevState.athleteData,
                team: team.name,
                teamID: team.id,
                name: '',
                lastname: '',
                category: null,
                categoryID: null
            },
            errors: {
                ...prevState.errors,
                team: ''
            }
        }));
    };

    selectNameLastname = (event) => {
        const val = event.target.value;

        this.setState((prevState) => ({
            ...prevState,
            selectedAthlete: val,
            athleteData: {
                ...prevState.athleteData,
                name: val.name,
                lastname: val.lastname,
                teamID: val.teamID,
                name_lastname: val.namelastname,
                team: val.team,
                photoID: val.PhotoID,
                projectID: val.projectID
            },
            errors: {
                ...prevState.errors,
                name: '',
                lastname: ''
            }
        }))
    };

    handleFormValidation = () => {

        const DEFAULT_TEXT = toJS(this.store.DEFAULT_TEXT);
        // const {athleteData, confirmed_email, termini_condizioni, termini_condizioni_mail, projectType, team_passed_from_url} = this.state;
        const {athleteData, termini_condizioni, projectType, team_passed_from_url} = this.state;

        let errors = {};
        let formIsValid = true;
        // let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (!athleteData.name_lastname) {
            // empty name
            if (!athleteData.name.trim()) {
                formIsValid = false;
                errors["name"] = DEFAULT_TEXT.error_empty_name;
            }

            //empty Lastname
            if (!athleteData.lastname.trim()) {
                formIsValid = false;
                errors["lastname"] = DEFAULT_TEXT.error_empty_lastname;
            }
        }

        // valid mail
        // if (athleteData.is_referent) {
        //     if (!re.test(athleteData.referent_mail)) {
        //         formIsValid = false;
        //         errors["email"] = DEFAULT_TEXT.error_not_valid_mail;
        //     }
        //
        //     // confirmed-mail === mail
        //     if (athleteData.referent_mail.localeCompare(confirmed_email)) {
        //         formIsValid = false;
        //         errors["emailconfirm"] = DEFAULT_TEXT.error_different_mail;
        //     }
        //
        //     if (athleteData.is_referent && !termini_condizioni_mail) {
        //         errors['termini_condizioni_mail'] = true;
        //         formIsValid = false;
        //     }
        //
        // } else {
        //     if (athleteData.referent_mail.trim()) {
        //         if (!re.test(athleteData.referent_mail)) {
        //             formIsValid = false;
        //             errors["email"] = DEFAULT_TEXT.error_not_valid_mail;
        //         }
        //     }
        //
        //     // confirmed-mail === mail
        //     if (athleteData.referent_mail.localeCompare(confirmed_email)) {
        //         formIsValid = false;
        //         errors["emailconfirm"] = DEFAULT_TEXT.error_different_mail;
        //     }
        //
        // }


        // team , category , terms_and_conditions
        if (projectType === 'C') {
            if (!athleteData.team) {
                errors['team'] = 'Select team *'
                formIsValid = false
            }
        }


        if(!team_passed_from_url.length > 0 && projectType === 'C') {
            if (!athleteData.team) {
                errors['team'] = 'Select team *'
                formIsValid = false
            }
        }

        if (!termini_condizioni) {
            errors['terms'] = 'I accept terms & conditions *'
            formIsValid = false
        }

        if (this.store.file === null) {
            errors['photo'] = true;
            formIsValid = false;
        }


        if (this.store.file_size > landing_page_max_photo_size || this.store.file_size < landing_page_min_photo_size) {

            this.store.error_file_size = true;
            formIsValid = false;
        }

        this.setState({errors: errors, formIsValid: formIsValid});

        return formIsValid;
    }

    saveAthleteData = () => {

        const {athleteData, projectID} = this.state;

        const self = this;
        if (this.handleFormValidation()) {
            
            self.setState({uploaded: true});

            let date_ob = new Date();

            let date = ("0" + date_ob.getDate()).slice(-2);
            let month = ("0" + (date_ob.getMonth() + 1)).slice(-2);
            let year = date_ob.getFullYear();
            let hours = date_ob.getHours();
            let minutes = date_ob.getMinutes();
            let seconds = date_ob.getSeconds();

            athleteData['upload_date'] = year + "-" + month + "-" + date + " " + hours + ":" + minutes + ":" + seconds;
            athleteData.is_referent = Number(athleteData.is_referent);
            athleteData.projectID = projectID;
            athleteData.photo = this.store.file;

            if (athleteData.photoID === null) {
                athleteData.photoID = '';
            }
            if (athleteData.teamID === null) {
                athleteData.teamID = this.state.projectData[0].TeamID;
            }

            this.store.save_athlete_data(athleteData, function (res) {

                if (res.success === true) {
                    const emailReferente = res.email_referente;
                    if (emailReferente === "") {
                        self.props.history.push('/confirm-upload-photo');
                        self.store.file = null;
                    } else {
                        self.registerToNewsletter(athleteData, emailReferente);
                    }
                } else {
                    self.showNotification("tc");
                }

                self.setState({uploaded: false});

            });
        }

    }

    registerToNewsletter = (athleteData, emailReferente) => {
        const self = this;
        const DEFAULT_TEXT = toJS(this.store.DEFAULT_TEXT);
        let params = {
            'email': emailReferente,
            newsletter_hello: DEFAULT_TEXT.hello,
            newsletter_text_email_1: DEFAULT_TEXT.newsletter_text_email_1,
            newsletter_text_email_2: DEFAULT_TEXT.newsletter_text_email_2,
            newsletter_text_email_3: DEFAULT_TEXT.newsletter_text_email_3,
            newsletter_text_email_4: DEFAULT_TEXT.newsletter_text_email_4,
            newsletter_text_email_5: DEFAULT_TEXT.newsletter_text_email_5,
            newsletter_thank: DEFAULT_TEXT.newsletter_thank,
            project_id: athleteData.projectID,
            'source': 'photoselfie',
            newsletter_unsubscribe_text: DEFAULT_TEXT.newsletter_unsubscribe_text,
            newsletter_unsubscribe_btn: DEFAULT_TEXT.newsletter_unsubscribe_btn,
            newsletter_unsubscribe_text_one: DEFAULT_TEXT.newsletter_unsubscribe_text_one,
        };

        self.store.check_newsletter_registration(params);
        self.props.history.push('/confirm-upload-photo');
        self.store.file = null;
    }

    closeAndReloadPage = () => {
        this.setState({setTC: false, tc: false});
        window.location.reload();
    }

    showNotification = (place) => {
        switch (place) {
            case "tc":
                if (!this.state.tc) {
                    this.setState({showUploadError: true, tc: true});
                }
                break;
            default:
                break;
        }
    };

    render() {
        // const self = this;
        const {
            uploaded,
            athleteData,
            selectedTeam,
            selectedCategory,
            selectedAthlete,
            projectData,
            projectType,
            url_ok,
            // team,
            // category,
            showUploadError,
            termini_condizioni,
            namelastname,
            // categoryReferent,
            errors,
            tc,
            // termini_condizioni_mail,
            // email,
            // confirmed_email,
            landing_page_enabled,
            showReferentCheckbox,
            // team_passed_from_url,
            url_with_team
        } = this.state;
        const DEFAULT_TEXT = toJS(this.store.DEFAULT_TEXT);
        let RenderHTML = (props) => (<li className='list-item' dangerouslySetInnerHTML={{__html: props.HTML}}></li>);
        // let RenderHTMLPara = (props) => (
            // <p className='para-couponinfo' dangerouslySetInnerHTML={{__html: props.HTML}}></p>);

        let selecttext = '';

        if (DEFAULT_TEXT.select_button !== undefined) {
            selecttext = DEFAULT_TEXT.select_button.toUpperCase();
        }

        let send_button = '';
        if (DEFAULT_TEXT.send_button !== undefined) {
            send_button = DEFAULT_TEXT.send_button.toUpperCase();
        }

        /*
        let privacy_url = '';
        if (this.store.lang === 'it' || this.store.lang === 'ii') {
            privacy_url = PRIVACY_URL + 'it/privacy/';
        } else if (this.store.lang === 'de' || this.store.lang === 'at' || this.store.lang === 'ch') {
            privacy_url = PRIVACY_URL + 'de/privacy/';
        } else if (this.store.lang === 'fr' || this.store.lang === 'ff' || this.store.lang === 'be') {
            privacy_url = PRIVACY_URL + 'fr/privacy/';
        }else if (this.store.lang === 'es') {
            privacy_url = PRIVACY_URL + 'es/privacy/';
        }else {
            privacy_url = PRIVACY_URL + this.store.lang + '/privacy/';
        }
        */

        //TODO change the all the filtering to API

        let uniqueCategories;
        let uniqueAthletes;
        let filteredAthletes;
        let filtered_categories;
        let showAthletesSelect;


        let uniqueTeams = [...new Map(projectData.map(item =>
            [item['TeamName'], Object.assign({
                name: item.TeamName,
                id: item.TeamID
            })])).values()]


        if (projectType === 'C') {
            filtered_categories = projectData.filter(obj => obj.TeamName === athleteData.team);

            uniqueCategories = [...new Map(filtered_categories.map(item =>
                [item['CategoryName'],
                    Object.assign({
                        id: item.CategoryID,
                        name: item.CategoryName
                    })])).values()];

            filteredAthletes = projectData.filter(obj => obj.TeamName === athleteData.team && obj.CategoryName === athleteData.category && obj.NomeCognome !== null);

            uniqueAthletes = [...new Map(filteredAthletes.map(item =>
                [item['NomeCognome'], Object.assign({
                    PhotoID: item.PhotoID,
                    name: item.Nome,
                    lastname: item.Cognome,
                    teamID: item.TeamID,
                    namelastname: item.NomeCognome,
                    team: item.TeamName,
                    projectID: item.ProjectID,
                    photoUploaded: item.PhotoUploaded
                })])).values()];

            showAthletesSelect = uniqueAthletes.length !== 0;
        } else {
            filteredAthletes = projectData.filter(obj => obj.CategoryName === athleteData.category && obj.NomeCognome !== null);

            uniqueAthletes = [...new Map(filteredAthletes.map(item =>
                [item['NomeCognome'], Object.assign({
                    PhotoID: item.PhotoID,
                    name: item.Nome,
                    lastname: item.Cognome,
                    teamID: item.TeamID,
                    namelastname: item.NomeCognome,
                    team: item.TeamName,
                    projectID: item.ProjectID,
                    photoUploaded: item.PhotoUploaded
                })])).values()];

            uniqueCategories = [...new Map(projectData.map(item =>
                [item['CategoryName'], Object.assign({id: item.CategoryID, name: item.CategoryName})])).values()];

            showAthletesSelect = uniqueAthletes.length !== 0;
        }

        return (
            <div>
                {
                    url_ok && url_with_team && (
                        
                        <div className='main-div'>
                            <div className='akinda-logo'>
                                <img className='img-akindalogo' src={Logo} alt='AkindaLogo'/>
                            </div>
                            <div className='wrapper-div'>
                                <div>
                                    <img className='img-photoselfie' src={PhotoSelfie} alt='Selfie'/>
                                </div>
                                <div
                                    className={landing_page_enabled ? 'landing-page-enabled' : 'landing-page-disabled'}>
                                    <div className={'introduction'}>
                                        <div><img className='img-photoselfie-logo' src={PhotoSelfieLogo} alt='PhotoSelfie'/></div>
                                        <span className='album-album'>{DEFAULT_TEXT.album}</span>
                                        <div className='polygon'>
                                            <span style={{paddingBottom: '1.5rem'}}>{DEFAULT_TEXT.utent_subtitle}</span>
                                        </div>
                                    </div>
                                </div>
                                {/* {!landing_page_enabled ? null : <div> */}
                                {landing_page_enabled && (
                                <div>
                                    <div className='instruction'>
                                        <div className='instruction-wrapper'>
                                            <p style={{paddingTop: '1rem'}}>{DEFAULT_TEXT.instruction}</p>
                                            <ol className='ordered-list'>
                                                <RenderHTML HTML={DEFAULT_TEXT.utent_instruction_nr1}/>
                                                <RenderHTML HTML={DEFAULT_TEXT.utent_instruction_nr2}/>
                                                <RenderHTML HTML={DEFAULT_TEXT.utent_instruction_nr3}/>
                                                <RenderHTML HTML={DEFAULT_TEXT.utent_instruction_nr4}/>
                                                {/*<RenderHTML HTML={DEFAULT_TEXT.utent_instruction_nr5}/>*/}
                                                <li style={{listStyle: "none", paddingBottom: '1.5rem'}} className='list-item'>{DEFAULT_TEXT.utent_instruction_NB}</li>
                                            </ol>
                                        </div>
                                    </div>
                                    <div className='form-input'>
                                        <hr className='horizontal-line'/>
                                        <img className='img-photoselfie' style={{marginTop: '3rem'}} src={Indicazioni} alt="Indicazioni"/>
                                        <form>
                                            <div className='flexbox'>
                                                {projectType === 'C' ?
                                                    <div className='flexbox-row'>
                                                        <label
                                                            className={errors["team"] ? 'label-red' : 'label'}>{DEFAULT_TEXT.select_team}
                                                            <span style={{color: "red", marginLeft: '0.2rem'}}>*</span></label>
                                                        <div className='wrapper-select'>
                                                            <Select
                                                                displayEmpty
                                                                disabled={selectedTeam !== null ? true : false}
                                                                renderValue={
                                                                    selectedTeam !== null ? () => <p className={'select-para'}>{selectedTeam.name}</p>
                                                                        : () => <p className={'select-para'}>{selecttext}</p>
                                                                }
                                                                fullWidth={true}
                                                                style={{color: 'white'}}
                                                                disableUnderline={true}
                                                                value={selectedTeam !== null ? selectedTeam.id : ''}
                                                                onChange={(e) => this.selectTeam(e)}
                                                                inputProps={{
                                                                    name: "simpleSelect",
                                                                    id: "simple-select"
                                                                }}>
                                                                {uniqueTeams.map((team, key) => {
                                                                    return (
                                                                        <MenuItem key={key} value={team}>
                                                                            <span className={'span-lang'}>{team.name}</span>
                                                                        </MenuItem>
                                                                    )
                                                                })}
                                                            </Select>
                                                        </div>
                                                    </div>

                                                    : null}


                                                <div className='flexbox-row'>
                                                    <label className={errors["category"] ? 'label-red' : 'label'}>{DEFAULT_TEXT.select_category}
                                                        <span style={{color: "red", marginLeft: '0.2rem'}}>*</span>
                                                    </label>
                                                    <div className='wrapper-select'>
                                                        <Select
                                                            displayEmpty
                                                            renderValue={
                                                                selectedCategory !== null ? () => <p className='select-para'>{selectedCategory.name}</p>
                                                                    : () => <p className='select-para'>{selecttext}</p>
                                                            }
                                                            fullWidth={true}
                                                            style={{color: 'white'}}
                                                            disableUnderline={true}
                                                            value={selectedCategory !== null ? selectedCategory.id : ''}
                                                            onChange={(e) => this.selectCategory(e)}
                                                            inputProps={{name: "simpleSelect", id: "simple-select"}}>
                                                            {uniqueCategories.map((cat, key) => {
                                                                return (
                                                                    <MenuItem key={key} value={cat}>
                                                                        <span className='span-lang'>{cat.name}</span>
                                                                    </MenuItem>
                                                                )
                                                            })}
                                                        </Select>
                                                    </div>
                                                </div>

                                                {
                                                    showAthletesSelect === true
                                                        ?
                                                        <div>
                                                            <div>
                                                                <hr className='horizontal-line-termini'/>
                                                            </div>
                                                            <div className='flexbox-row'>
                                                                <label className='label'>{DEFAULT_TEXT.select_name_lastname}</label>
                                                                <div className='wrapper-select'>
                                                                    <Select
                                                                        displayEmpty
                                                                        renderValue={
                                                                            selectedAthlete !== null
                                                                                ? () => <p className='select-para'>{selectedAthlete.name} {selectedAthlete.lastname}</p>
                                                                                : () => <p className='select-para'>{selecttext}</p>
                                                                        }
                                                                        fullWidth={true}
                                                                        style={{color: 'white'}}
                                                                        disableUnderline={true}
                                                                        value={selectedAthlete !== null ? selectedAthlete.PhotoID : ''}
                                                                        onChange={(e) => this.selectNameLastname(e)}>
                                                                        {uniqueAthletes.map((athlete, key) => {
                                                                            return (
                                                                                <MenuItem key={key} value={athlete}>
                                                                                    <span className={'span-lang'}>{athlete.name} {athlete.lastname} </span>
                                                                                    {
                                                                                        athlete.photoUploaded === 1 ? <span role="img" style={{marginLeft: '0.2rem'}}>✅</span>: null
                                                                                    }
                                                                                </MenuItem>
                                                                            )
                                                                        })}
                                                                    </Select>
                                                                </div>
                                                            </div>

                                                            {
                                                                selectedAthlete == null
                                                                ?   <div className='after-lastname'>
                                                                        <p className='paragraph'>{DEFAULT_TEXT.or}</p>
                                                                    </div>
                                                                : null
                                                            }

                                                        </div>
                                                    : null
                                                }


                                                {
                                                    selectedAthlete == null
                                                    ?
                                                        <div>
                                                            <div className='flexbox-row'>
                                                                <label
                                                                    className={(!namelastname && errors["name"]) ? 'label-red' : 'label'}>{errors["name"] ? errors["name"] : DEFAULT_TEXT.insert_name} {!namelastname ?
                                                                    <span style={{
                                                                        color: "red",
                                                                        marginLeft: '0.2rem'
                                                                    }}>*</span> : null} </label>
                                                                <input
                                                                    type="text"
                                                                    ref="name"
                                                                    className='simple-input'
                                                                    placeholder={DEFAULT_TEXT.name} style={{textAlign: "center"}}
                                                                    onChange={(e) => {
                                                                        const val = e.target.value;
                                                                        this.setState((prevState) => ({
                                                                            ...prevState,
                                                                            athleteData: {
                                                                                ...prevState.athleteData,
                                                                                name: val
                                                                            },
                                                                            errors: {
                                                                                ...prevState.errors,
                                                                                name: ''
                                                                            }
                                                                        }))
                                                                    }}/>
                                                            </div>

                                                            <div className='flexbox-row'>
                                                                <label
                                                                    className={(!namelastname && errors["lastname"]) ? 'label-red' : 'label'}>
                                                                    {errors["lastname"] ? errors["lastname"] : DEFAULT_TEXT.insert_lastname}
                                                                    {!namelastname ?
                                                                        <span style={{
                                                                            color: "red",
                                                                            marginLeft: '0.2rem'
                                                                        }}>*</span> : null}
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    ref="lastname"
                                                                    className='simple-input'
                                                                    placeholder={DEFAULT_TEXT.lastname}
                                                                    style={{textAlign: "center"}}
                                                                    onChange={(e) => {
                                                                        const val = e.target.value;
                                                                        this.setState((prevState) => ({
                                                                            ...prevState,
                                                                            athleteData: {
                                                                                ...prevState.athleteData,
                                                                                lastname: val
                                                                            },
                                                                            errors: {
                                                                                ...prevState.errors,
                                                                                lastname: ''
                                                                            }
                                                                        }))

                                                                    }}/>
                                                            </div>
                                                        </div>

                                                    : null
                                                }


                                                <div className='flexbox-row'>
                                                    <label id='image'
                                                           className={this.store.file === null && errors['photo'] ? 'label-red' : 'label'}>{DEFAULT_TEXT.upload_photo}<span
                                                        style={{color: "red", marginLeft: '0.2rem'}}>*</span> </label>

                                                    <div
                                                        className={this.store.file === null ? 'wrapper-select' : 'wrapper-upload'}>
                                                        <ImageUpload/>
                                                    </div>
                                                </div>
                                                <div className='flexbox-row'>
                                                    <div style={{visibility: 'hidden'}}>just for positioning</div>
                                                    <p className={this.store.error_file_size ? 'max-size-error' : 'max-size'}>{DEFAULT_TEXT.max_file_size}</p>
                                                </div>
                                                {showReferentCheckbox === true ?
                                                    <div className='config-checkbox' style={{marginTop: "2rem"}}>
                                                        <input
                                                            type="checkbox"
                                                            checked={athleteData.is_referent}
                                                            onChange={(e) => {
                                                                this.setState((prevState) => ({
                                                                    ...prevState,
                                                                    athleteData: {
                                                                        ...prevState.athleteData,
                                                                        is_referent: !prevState.athleteData.is_referent,
                                                                    }, errors: {
                                                                        ...prevState.errors,
                                                                        email: '',
                                                                        emailconfirm: ''
                                                                    }
                                                                }))
                                                            }}/>
                                                        <div>
                                                            <p className='para-checkbox'>{DEFAULT_TEXT.is_category_referent}</p>
                                                        </div>
                                                    </div> : null}

                                                <div className='config-checkbox'>
                                                    <input
                                                        type="checkbox"
                                                        checked={termini_condizioni}
                                                        onChange={(e) => {
                                                            this.setState((prevState) => ({
                                                                ...prevState,
                                                                termini_condizioni: !prevState.termini_condizioni,
                                                                errors: {
                                                                    ...prevState.errors,
                                                                    terms: ''
                                                                }
                                                            }))
                                                        }}/>
                                                    <div style={{display: 'flex', alignItems: 'baseline'}}>
                                                        <p className={errors['terms'] ? 'para-checkbox-red' : 'para-checkbox'}>{DEFAULT_TEXT.accept_terms}</p>
                                                        {/*<p onClick={() => {*/}
                                                        {/*    window.open(privacy_url, "_blank")*/}
                                                        {/*}}*/}
                                                        {/*   className={errors['terms'] ? 'para-checkbox-red' : 'para-checkbox-blue'}*/}
                                                        {/*   style={{*/}
                                                        {/*       marginLeft: '3px',*/}
                                                        {/*       cursor: 'pointer'*/}
                                                        {/*   }}>{DEFAULT_TEXT.terms_conditions}</p>*/}


                                                        {/*<p onClick={() => {window.open(privacy_url, "_blank")}}*/}
                                                        {/*   className={errors['terms'] ? 'para-checkbox-red' : 'para-checkbox-blue'}*/}
                                                        {/*   style={{*/}
                                                        {/*       marginLeft: '3px',*/}
                                                        {/*       cursor: 'pointer'*/}
                                                        {/*   }}>{DEFAULT_TEXT.accept_terms_and_conditions}</p>*/}


                                                        <p onClick={() => {
                                                            this.store.lang === 'it' || this.store.lang === 'ii'
                                                                ? window.open(terms_conditions_privacy_policy_IT, "_blank")
                                                                : this.store.lang === 'de' || this.store.lang === 'at' || this.store.lang === 'ch'
                                                                    ? window.open(terms_conditions_privacy_policy_DE, "_blank")
                                                                    : this.store.lang === 'fr' || this.store.lang === 'ff' || this.store.lang === 'be'
                                                                        ? window.open(terms_conditions_privacy_policy_FR, "_blank")
                                                                        : this.store.lang === 'es'
                                                                            ? window.open(terms_conditions_privacy_policy_ES, "_blank")
                                                                            : window.open(terms_conditions_privacy_policy_EN, "_blank")
                                                        }}
                                                           className={(errors["termini_condizioni_mail"] && athleteData.is_referent) ? 'para-checkbox-red' : 'para-checkbox-blue'}
                                                           style={{
                                                               marginLeft: '5px',
                                                               cursor: 'pointer'
                                                           }}>{DEFAULT_TEXT.accept_terms_and_conditions}</p>




                                                        <span
                                                            style={{
                                                                fontFamily: "Helvetica Neue",
                                                                fontSize: '1rem',
                                                                fontWeight: 'bold',
                                                                color: "red",
                                                                marginLeft: '0.2rem',
                                                                paddingRight: '1.2rem'
                                                            }}>*</span>
                                                    </div>
                                                </div>

                                                <div>
                                                    <hr className='horizontal-line-termini'/>
                                                </div>

                                                {/*<div style={{marginTop: '2rem'}}>*/}
                                                {/*    <RenderHTMLPara HTML={DEFAULT_TEXT.utent_instruction_nr6}/>*/}
                                                {/*</div>*/}

                                                {/*<div className='flexbox'>*/}
                                                {/*    <div className='flexbox-row'>*/}
                                                {/*        <label*/}
                                                {/*            className={errors["email"] ? 'label-red' : 'label'}>{errors["email"] ? errors["email"] : DEFAULT_TEXT.email}*/}
                                                {/*            {athleteData.is_referent ?*/}
                                                {/*                <span style={{*/}
                                                {/*                    color: "#FF0000",*/}
                                                {/*                    marginLeft: '0.2rem'*/}
                                                {/*                }}>*</span> : null}*/}
                                                {/*        </label>*/}
                                                {/*        <input*/}
                                                {/*            type="text"*/}
                                                {/*            ref="email"*/}
                                                {/*            className='simple-input'*/}
                                                {/*            placeholder={DEFAULT_TEXT.insert_email}*/}
                                                {/*            style={{textAlign: "center"}}*/}
                                                {/*            onChange={(e) => {*/}
                                                {/*                const val = e.target.value;*/}
                                                {/*                this.setState((prevState) => ({*/}
                                                {/*                    ...prevState,*/}
                                                {/*                    athleteData: {*/}
                                                {/*                        ...prevState.athleteData,*/}
                                                {/*                        referent_mail: val*/}
                                                {/*                    },*/}
                                                {/*                    errors: {*/}
                                                {/*                        ...prevState.errors,*/}
                                                {/*                        email: ''*/}
                                                {/*                    }*/}
                                                {/*                }))*/}
                                                {/*            }}/>*/}
                                                {/*    </div>*/}
                                                {/*</div>*/}


                                                {/*<div className='flexbox'>*/}
                                                {/*    <div className='flexbox-row'>*/}
                                                {/*        <label*/}
                                                {/*            className={errors["emailconfirm"] ? 'label-red' : 'label'}> {errors["emailconfirm"] ? errors["emailconfirm"] : DEFAULT_TEXT.confirm_email}*/}
                                                {/*            {athleteData.is_referent ?*/}
                                                {/*                <span style={{*/}
                                                {/*                    color: "#FF0000",*/}
                                                {/*                    marginLeft: '0.2rem'*/}
                                                {/*                }}>*</span> : null}*/}
                                                {/*        </label>*/}
                                                {/*        <input*/}
                                                {/*            type="text" ref="confirm-mail"*/}
                                                {/*            className='simple-input'*/}
                                                {/*            style={{textAlign: 'center'}}*/}
                                                {/*            placeholder={DEFAULT_TEXT.email_confirm_message}*/}
                                                {/*            onChange={(e) => {*/}
                                                {/*                const val = e.target.value;*/}
                                                {/*                this.setState((prevState) => ({*/}
                                                {/*                    ...prevState,*/}
                                                {/*                    confirmed_email: val,*/}
                                                {/*                    errors: {*/}
                                                {/*                        ...prevState.errors,*/}
                                                {/*                        emailconfirm: ''*/}
                                                {/*                    }*/}
                                                {/*                }))*/}
                                                {/*            }}/>*/}
                                                {/*    </div>*/}
                                                {/*</div>*/}

                                                {/*<div className='config-checkbox'*/}
                                                {/*     style={{marginTop: '2rem'}}>*/}
                                                {/*    <input type="checkbox"*/}
                                                {/*           checked={termini_condizioni_mail}*/}
                                                {/*           onChange={(e) => {*/}
                                                {/*               this.setState((prevState) => ({*/}
                                                {/*                   ...prevState,*/}
                                                {/*                   termini_condizioni_mail: !prevState.termini_condizioni_mail,*/}
                                                {/*                   errors: {*/}
                                                {/*                       ...prevState.errors,*/}
                                                {/*                       termini_condizioni_mail: ""*/}
                                                {/*                   }*/}
                                                {/*               }))*/}
                                                {/*           }}/>*/}
                                                {/*    <div className='termini-condizioni'>*/}
                                                {/*        /!*<p className={(errors["termini_condizioni_mail"] && athleteData.is_referent) ? 'para-checkbox-red' : 'para-checkbox'}>{DEFAULT_TEXT.accept_terms}</p>*!/*/}

                                                {/*        <p onClick={() => {*/}
                                                {/*            window.open(privacy_url, "_blank")*/}
                                                {/*        }}*/}
                                                {/*           className={(errors["termini_condizioni_mail"] && athleteData.is_referent) ? 'para-checkbox-red' : 'para-checkbox-blue'}*/}
                                                {/*           style={{*/}
                                                {/*               marginLeft: '5px',*/}
                                                {/*               cursor: 'pointer'*/}
                                                {/*           }}>{DEFAULT_TEXT.accept_send_promotions_email}</p>*/}

                                                {/*        {athleteData.is_referent ?*/}
                                                {/*            <span style={{*/}
                                                {/*                color: "#FF0000",*/}
                                                {/*                marginLeft: '0.2rem'*/}
                                                {/*            }}>*</span> : null}*/}
                                                {/*    </div>*/}
                                                {/*</div>*/}








                                                {/*<div*/}
                                                {/*    className={uploaded ? 'send-button-disabled' : 'send-button'}*/}
                                                {/*    onClick={() => this.saveAthleteData()}*/}

                                                {/*> {send_button} </div>*/}

                                                {
                                                    uploaded
                                                        ? <div className={'send-button-disabled'}>{send_button}</div>
                                                        : <div className={'send-button'} onClick={() => this.saveAthleteData()}>{send_button}</div>
                                                }
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                )}

                            </div>
                        </div>
                        // : <h1></h1>
                )}
                {
                    showUploadError && (
                        <GridContainer>
                            <ItemGrid xs={12} sm={12} md={12}>
                                <Card>

                                    <div>
                                        <GridContainer justify="center">
                                            <ItemGrid xs={12} sm={12} md={3}>
                                                <Snackbar
                                                    place="tc"
                                                    color="danger"
                                                    icon={AddPhoto}
                                                    message={DEFAULT_TEXT.uploadFailed}
                                                    open={tc}
                                                    closeNotification={() => this.closeAndReloadPage()}
                                                    close
                                                />
                                            </ItemGrid>
                                        </GridContainer>
                                    </div>
                                </Card>
                            </ItemGrid>
                        </GridContainer>
                        
                )}
            </div>
        )
    }
}

export default UploadPhotoRefactored;



// WEBPACK FOOTER //
// ./src/views/Users/UploadPhotoRefactored.jsx